import { palette } from '@cbhq/cds-web/tokens';
import { paletteValueToCssVar } from '@cbhq/cds-web/utils/palette';

/*
 * 2019 Design System color palatte.
 * Should only be accessed from theme.js, and never directly.
 *
 * Don't add/remove without signoff from #design-systems
 */

const toCssVar = value => paletteValueToCssVar(value);
const bgOverlay = 'rgba(50, 53, 61, 0.33)';
const black30 = toCssVar(['gray100', 0.3]);
const black50 = toCssVar(['gray100', 0.5]);
const black70 = toCssVar('gray100');
const black0 = toCssVar(['gray100', 0.0001]);
const blue = palette.primary;
const blueHover = toCssVar('blue70');
const blueActive = toCssVar('blue80');
const blueWash = palette.primaryWash;
const blueWashAlt = toCssVar(['blue80', 0.03]);
const blue5 = toCssVar('blue5');
const blue10 = toCssVar('blue10');
const blue20 = toCssVar('blue20');
const gray10 = toCssVar('gray10');
const green = palette.positive;
const greenHover = toCssVar('green50');
const greenLight = toCssVar('green10');
const grey2 = toCssVar(['gray80', 0.02]);
const grey15 = toCssVar('gray15');
const grey30 = toCssVar(['gray80', 0.33]);
const grey40 = toCssVar('gray40');
const grey6 = toCssVar('gray5');
const grey60 = toCssVar('gray60');
const grey90 = toCssVar('gray90');
const grey6Hover = toCssVar('gray10');
const greyDark = toCssVar('gray60');
const lightBlue = palette.primaryWash;
const red = palette.negative;
const redHeavy = palette.negative;
const negativeForeground = palette.negativeForeground;
const transparent = 'transparent';
const white = toCssVar('gray0');
const white25 = toCssVar(['gray0', 0.25]);
const white40 = toCssVar(['gray0', 0.4]);
const white60 = toCssVar(['gray0', 0.6]);
const white70 = toCssVar(['gray0', 0.7]);
const white0 = toCssVar(['gray0', 0.0001]);
const yellow = toCssVar('yellow30');
const line = palette.line;
export { bgOverlay, black0, black30, black50, black70, blue, blue10, blue20, blue5, blueActive, blueHover, blueWash, blueWashAlt, gray10, green, greenHover, greenLight, grey15, grey2, grey30, grey40, grey6, grey60, grey6Hover, grey90, greyDark, lightBlue, line, negativeForeground, red, redHeavy, toCssVar, transparent, white, white0, white25, white40, white60, white70, yellow };
//# sourceMappingURL=colors.js.map
